import salesTypeEnums from '../../../../variables/ski/pass/sales-type-enums';
import statusEnums from '../../../../variables/ski/pass/status-type-enums';

const getDefaultState = () => ({
  pass: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveError: undefined,
    saveLoading: false,
    newPassItem: {
      id: undefined,
      bookingParticipantId: undefined,
      productsSkiPassSeasonId: undefined,
      productsSkiPassPersonCategoryId: undefined,
      status: statusEnums.INITIATED,
      salesType: salesTypeEnums.BOOKING,
      supplierRef: undefined,
      firstSkiDay: undefined,
      numberOfDays: undefined,
      price: undefined,
      priceNet: undefined,
      keyCardGross: undefined,
      keyCardNet: undefined,
      currencyNet: undefined,
      supplierName: undefined,
      seasonName: undefined,
      personCategoryName: undefined,
      seasonNameSupplier: undefined,
      personCategoryNameSupplier: undefined,
      discount: undefined,
      discountNet: undefined,
      discountBookFrom: undefined,
      discountBookTo: undefined,
    },
  },
  bookingParticipants: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  availablePassProducts: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
    saveError: undefined,
    saveLoading: false,
  },
  search: {
    selectedBookingParticipantId: null,
    selectedStartDate: undefined,
    selectedNumberOfDays: 2,
    availableNumberOfDays: [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14],
    selectedAreaId: null,
  },
  changeProduct: {
    selectedBookingParticipantId: undefined,
    selectedPersonCategoryId: undefined,
    selectedStartDate: undefined,
    selectedNumberOfDays: undefined,
  },
  pickupPlaces: {
    loading: false,
    error: false,
    items: [],
  },
  savePickupPlace: {
    loading: false,
    error: false,
    success: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/pass/defaultState.js